import React from 'react';
import { SubHeaderRails } from '../../../components/sub-header/SubHeaderRails';
import { EnterpriseActionSlider } from './EnterpriseActionSlider';
import { MobileBar } from '../../../components/mobile-bar/MobileBar';

type Props = {
  isVisible: boolean;
};

export const EnterpriseMobileBar = ({ isVisible }: Props) => (
  <MobileBar>
    <SubHeaderRails>
      <EnterpriseActionSlider isVisible={isVisible} />
    </SubHeaderRails>
  </MobileBar>
);
